export default [
    {
        path: "/test",
        name: "Test",
        meta: {
            title: "test",
            langKey: "test",
            noAuth: true,
        },
        component: () => import("../../views/Test.vue"),
    },
    {
        path: "/cloud/download",
        name: "Download",
        meta: {
            title: "common.link.share",
        },
        component: () => import("../../views/Cloud/Download/index.vue"),
    },
    {
        path: "/cloud/info",
        name: "Info",
        meta: {
            title: "common.share.content",
        },
        component: () => import("../../views/Cloud/Download/Info.vue"),
    },
    {
        path: "/login",
        name: "Login",
        meta: {
            title: "common.login",
            langKey: "common.login",
            noAuth: true,
        },
        component: () => import("../../views/Login/Login.vue"),
    },
    {
        path: "/guide",
        name: "Guide",
        meta: {
            title: "common.share.guide",
            noAuth: true,
        },
        component: () => import("../../views/FileDoc/view/HomeIndex.vue"),
    },
    {
        path: "/whatsappdoc",
        name: "WhatsappDoc",
        meta: {
            title: "common.whatsapp.doc",
            noAuth: true,
        },
        component: () => import("../../views/WhatsApp/whatsappDoc.vue"),
    },
    {
        path: "/settingguide",
        name: "SettingGuide",
        meta: {
            title: "common.setting.guide",
            noAuth: true,
        },
        component: () => import("../../views/FileDoc/view/SettingIndex.vue"),
    },
    {
        path: "/can",
        name: "Can",
        component: () => import("../../components/Dashboard/ElCalender/index.vue"),
    },
    {
        path: "/register",
        name: "Register",
        meta: {
            title: "common.register",
            noAuth: true,
        },
        component: () => import("../../views/Register.vue"),
    },
    {
        path: "/forgetPassword",
        name: "ForgetPassword",
        meta: {
            title: "common.forgetpassword",
            noAuth: true,
        },
        component: () => import("../../views/ForgetPassword/index.vue"),
    },
    {
        path: "/companyregister",
        name: "CompanyRegister",
        meta: {
            title: "common.register",
            noAuth: true,
        },
        component: () => import("../../views/CompanyRegister.vue"),
    },
    {
        path: "/companyRegister",
        name: "CompanyRegisterAlias",
        meta: {
            title: "common.register",
            noAuth: true,
        },
        component: () => import("../../views/CompanyRegister.vue"),
    },
];
